core-banner {
  display: block;
}

.core-banner {
  display: flex;
  align-items: center;
  border-radius: var(--number-radius-large);
  padding: var(--number-spacing-2xsmall);
  box-shadow: var(--effect-drop-small);
}

.core-banner:not(.core-banner--inline-buttons) {
  display: block;
}

/* Status */
.core-banner.banner-status--success {
  background-color: var(--color-status-background-success);
}
.core-banner.banner-status--warning {
  background-color: var(--color-status-background-warning);
}
.core-banner.banner-status--error {
  background-color: var(--color-status-background-error);
}
.core-banner.banner-status--information {
  background-color: var(--color-status-background-information);
}
.core-banner.banner-status--neutral {
  background-color: var(--color-neutral-background-strong);
}

/* content */
.core-banner .banner-content {
  display: flex;
  flex: 1;
  gap: var(--number-spacing-2xsmall);
  padding: var(--number-spacing-2xsmall);
}

.core-banner .banner-content .icon-box {
  display: flex;
  padding: var(--number-spacing-5xsmall);
}

.core-banner .banner-content .text-box {
  display: flex;
  flex-direction: column;
}

.core-banner .banner-content .banner-headline {
  color: var(--color-neutral-content-strong);
}

.core-banner .banner-content .banner-message {
  color: var(--color-neutral-content-medium);
}

/* Make sure slot actions are displayed correctly */
.core-banner .banner-actions, .core-banner .banner-actions > * {
  display: flex;
}

.core-banner:not(.core-banner--inline-buttons) .banner-content-wrapper {
  display: flex;
}

.core-banner:not(.core-banner--inline-buttons) .banner-actions {
  justify-content: flex-end;
}
